<div
    style="text-align-last: center; text-align: -webkit-center;text-align: -moz-center; margin-top: 3rem; margin-bottom: 3rem;">
    <div class="card" style="width: 75%; min-width: 50rem;">
        <mat-card-content>
            <div style="width: 100%; text-align: center;">
                <h1 class="welcome">{{'HOME_T1' | translate}}</h1>


                <div style="display: flex; margin-left: 2rem; margin-right: 2rem;">
                    <div style="text-align-last: left;  width: 60%;" id="textDiv">
                        <div>
                            <p style="text-align:justify;">
                                {{'HOME_P1' | translate}}
                            </p>

                            <p *ngIf="isLogged" style="text-align:justify;">
                                {{'HOME_P3' | translate}}
                            </p>
                            <p *ngIf="isLogged" style="text-align:justify;">
                                {{'HOME_SUGGESTED_BROWSERS' | translate}}
                            </p>

                            <p *ngIf="isLogged" style="text-align:justify;">
                                {{'HOME_P4' | translate}}
                            </p>

                            <p *ngIf="isLogged" style="text-align:justify;">
                                {{'HOME_P5' | translate}}
                            </p>

                            <p *ngIf="!isLogged" style="text-align:justify;">
                                {{'HOME_P2' | translate}}
                            </p>
                            <p *ngIf="!isLogged" style="text-align:justify;">
                                {{'HOME_SUGGESTED_BROWSERS' | translate}}
                            </p>

                        </div>

                    </div>

                    <div
                        style="margin-left: 1rem; width: 40%; padding-top: 18px; max-height: inherit; display: flex; justify-content: center;">
                        <img *ngIf="!isLogged" src="../../../assets/logo.png"
                            style="width: 200px; height: 200px; align-self: center;">
                        <img *ngIf="isLogged" src="../../../assets/logo.png"
                            style="width: 280px; height: 280px; align-self: center;">
                    </div>
                </div>

                <!--REGISTER BUTTON IF NOT LOGGED-->
                <div *ngIf="!isLogged">
                    <div style="display: flex; justify-content: center;">
                        <button class="button" (click)="register()" mat-raised-button>{{'HOME_REGISTER' |
                            translate}}</button>
                    </div>
                </div>

                <div style="margin-bottom: 2rem;">
                    <button [disabled]="Demographic" mat-raised-button *ngIf="isLogged"
                        [routerLink]="['/questionnaire?type=Demographic']" (click)="demographic()"
                        class="link-button">{{'HOME_LINK1' |
                        translate}} <br> (&#60; 5 {{'MINUTES' | translate}})</button>

                    <button [disabled]="Covid" mat-raised-button *ngIf="isLogged" [routerLink]="['/covid?type=Covid']"
                        (click)="covid()" class="link-button">{{'HOME_LINK2' |
                        translate}} <br> (&#60; 5 {{'MINUTES' | translate}})</button>

                    <button [disabled]="WordCategorization" mat-raised-button *ngIf="isLogged" [routerLink]="['/memory-experiment']" (click)="memexp()"
                        class="link-button">{{'HOME_LINK3' |
                        translate}} <br> (&#126; 25 {{'MINUTES' | translate}})</button>

                    <button [disabled]="FlashBeep" mat-raised-button *ngIf="isLogged" [routerLink]="['/flash-beep']" (click)="flashBeep()"
                        class="link-button">{{'HOME_LINK4' |
                        translate}} <br> (&#126; 10 {{'MINUTES' | translate}})</button>

                    <button [disabled]="Personality" mat-raised-button *ngIf="isLogged"
                        [routerLink]="['/personality-survey']" (click)="personality()"
                        class="link-button">{{'HOME_LINK5' |
                        translate}} <br> (&#60; 5 {{'MINUTES' | translate}})</button>

                    <button [disabled]="LoudnessPerception" mat-raised-button *ngIf="isLogged" [routerLink]="['/loudness-perception']"
                        (click)="loudnessPerception()" class="link-button">{{'HOME_LINK6' |
                        translate}} <br> (&#126; 5 {{'MINUTES' | translate}})</button>

                    <button [disabled]="TargetDetection" mat-raised-button *ngIf="isLogged" [routerLink]="['/target-detection']"
                        (click)="targetDetection()" class="link-button">{{'HOME_LINK7'
                        |
                        translate}} <br> (&#126; 25 {{'MINUTES' | translate}})</button>
                    <button [disabled]="MovementPerception" mat-raised-button *ngIf="isLogged" [routerLink]="['/movement-perception']"
                        (click)="movementPerception()" class="link-button">{{'HOME_LINK8' |
                        translate}} <br> (&#126; 10 {{'MINUTES' | translate}})</button>

                    <button [disabled]="Quality" mat-raised-button *ngIf="isLogged"
                        [routerLink]="['/covid?type=Quality']" (click)="quality()" class="link-button">{{'HOME_LINK9' |
                        translate}} <br> (&#60; 5 {{'MINUTES' | translate}})</button>

                    <button [disabled]="Fatigue" mat-raised-button *ngIf="isLogged"
                        [routerLink]="['/covid?type=Fatigue']" (click)="fatigue()" class="link-button">{{'HOME_LINK10' |
                        translate}} <br> (&#60; 5 {{'MINUTES' | translate}})</button>
                </div>
            </div>

        </mat-card-content>
        <mat-card-actions>
        </mat-card-actions>
    </div>
</div>